import { render, staticRenderFns } from "./DashboardInfoWidgets.vue?vue&type=template&id=b6e65ada&scoped=true&"
import script from "./DashboardInfoWidgets.vue?vue&type=script&lang=js&"
export * from "./DashboardInfoWidgets.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInfoWidgets.vue?vue&type=style&index=0&id=b6e65ada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e65ada",
  null
  
)

component.options.__file = "DashboardInfoWidgets.vue"
export default component.exports